
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { HistoryItemType } from '@/features/shipment-history/types';
import { ShipTo } from '@/features/shipment/types';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class AddressInfo extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) item!: HistoryItemType;

  @Prop({ default: 'toAddress' }) field!: string;

  get addressInfo(): string {
    const address: ShipTo = this.item[this.field];
    const firstRow = [address.contact, address.company].join(', ');
    const secondRow = [address.addr1, address.city, address.province].filter(Boolean).join(', ');

    return `${firstRow}<br /> ${secondRow}`;
  }

  get title(): string {
    return this.$t(`shipment.${this.field === 'toAddress' ? 'shipTo' : 'shipFrom'}`) as string;
  }
}
